import {createContext} from "react";

const AccessTokenContext = createContext(null);

export default AccessTokenContext;